import { useTranslation } from "react-i18next";

interface Props {
  restaurantName?: string;
}

export const SplashScreen = ({ restaurantName }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen gradient-warm flex flex-col items-center justify-center px-6 text-center animate-fade-in">
      <div className="text-5xl mb-6" aria-hidden="true">
        🍽️
      </div>
      <h1 className="display-font text-3xl font-semibold text-ink leading-tight">
        {restaurantName ?? t("splash.preparing", "Préparation")}
      </h1>
      <p className="text-ink-soft mt-2 text-sm">{t("splash.loadingTable", "Chargement de votre table…")}</p>

      <div
        className="mt-10 w-10 h-10 rounded-full border-4 border-pink-soft border-t-primary animate-spin"
        role="status"
        aria-label={t("splash.loading", "Chargement")}
      />
    </div>
  );
};
